<template>

    <div class="p-relative">

        <Toolbar
            :is-list="true"
            v-on:toolbar-button-click="onToolbarClick"
        >
            <SearchPanel
                v-model="search"
                :has-filter="false"
            />
        </Toolbar>

        <FilterPanel
            v-if="filterDataSource"
            :dataSource="filterDataSource"
            v-bind:status.sync="status"
        >
        </FilterPanel>

        <v-row no-gutters>

            <v-col cols="12" xs="12" md="12">
                <v-data-table
                    :loading="loading"
                    :headers="headers"
                    :items="entities"
                    :options.sync="options"
                    :server-items-length="total"
                    :items-per-page="10"
                    :footer-props="{ itemsPerPageOptions:[5, 10, 20] }"
                    :page.sync="options.page"
                    @page-count="paginationPageCount = $event"
                    class="elevation-1 customization-list-table pagination-list-table sticky-table"
                    @dblclick:row="rowClick"
                >

                    <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>
                    
                    <template v-slot:[`item.document_type`]="{ item }">
                        <div class="elipsis-text-wrap">
                            <div class="etw-text-container">
                                <div class="etw-text" v-tooltip.top-center="item.document_type">
                                    {{ item.document_type }}
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.template_name`]="{ item }">
                        <div class="elipsis-text-wrap">
                            <v-icon 
                                v-if="item.is_public"
                                color="#228ac7"
                                small
                                v-tooltip.top-center="status == '1'
                                    ? $t('Шаблон_можно_скопировать_в_схему_организации')
                                    : $t('Шаблон_можно_использовать_для_создания_документов')"
                            >
                                {{ status == '1' ? 'fas fa-cloud-arrow-down' : 'fas fa-cloud-arrow-up' }}
                            </v-icon>
                            <div class="etw-text-container">
                                <div class="etw-text" v-tooltip.top-center="item.template_name">
                                    {{ item.template_name }}
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.scheme_name`]="{ item }">
                        <div class="elipsis-text-wrap">
                            <div class="etw-text-container">
                                <div class="etw-text" v-tooltip.top-center="item.scheme_name">
                                    {{ item.scheme_name }}
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`footer.prepend`]>
                        <v-pagination
                            v-model="options.page"
                            :length="paginationPageCount"
                            :total-visible="$listPaginationTotal"
                            color="teal"
                        ></v-pagination>
                    </template>

                </v-data-table>
            </v-col>

        </v-row>

    </div>

</template>

<script>
import _ from 'lodash';
import { mapActions } from 'vuex';

import { httpAPI } from "@/api/httpAPI";
import Toolbar from '@/components/documents/Toolbar.vue';
import SearchPanel from '@/components/documents/SearchPanel.vue';
import FilterPanel from '@/components/documents/FilterPanel.vue';

//const type = 'Documents.Template';

export default {
    name: "Templates",
    columnIndex:  {
        'document_type': 2,
        'template_name': 3,
        'scheme_name': 6
    },
    components: {
        Toolbar,
        FilterPanel,
        SearchPanel
    },
    computed : {
        headers() {
            return [
                { text: this.$t("Тип"), value: 'document_type', width: '150px' },
                { text: this.$t("Наименование"), value: 'template_name' },
                { text: this.$t("Схема"), value: 'scheme_name', width: '150px' }
            ];
        },
        status: {
            get: function() {
                return this.$store.getters['global/configuration/templates/getStatus'];
            },
            set: function(newValue) {
                this.$store.commit('global/configuration/templates/SET_STATUS', newValue);
            }
        },
        search: {
            get: function() {
                return this.$store.getters['global/configuration/templates/getTableSearch'];
            },
            set: _.debounce(function(v) {
                this.$store.commit('global/configuration/templates/SET_TABLE_OPTION_PAGE', 1);
                this.$store.commit('global/configuration/templates/SET_TABLE_SEARCH', v);
            }, 500)
        },
        options: {
            get: function() {
                return this.$store.getters['global/configuration/templates/getTableOptions'];
            },
            set: function(newValue) {
                this.$store.commit('global/configuration/templates/SET_TABLE_OPTION', newValue);
            }
        },
        filter() {
            return {
                ...this.options,
                SearchStr: this.search,
                Status: this.status
            }
        }
    },
    data() {
        return {
            loading: true,
            total: 0,
            entities: [],
            dataSource: null,
            filterDataSource: null,
            paginationPageCount: 0,
        }
    },    
    methods: {
        ...mapActions(['setOverlayVisible']),
        onToolbarClick(event, btn) {
            this[btn.Action](btn);
        },
        async getData(isRefresh = false) {
            let filterJson = this.getSerializedFilter();
            let newFilterObj = JSON.parse(filterJson);

            if (isRefresh === false && this.$_.isEqual(this.prevTableFilterObject, newFilterObj))
                return;

            this.setOverlayVisible({ visible: true });
            this.prevTableFilterObject = newFilterObj;
            this.total = 0;
            this.loading = true;

            let response = await httpAPI({
                url: `api/document-templates/templates/list?filter=${filterJson}`,
                method: 'GET',
                headers: { 'isCommon': this.status == "1" },
            });

            this.entities = response?.data?.Payload?.data ?? [];
            this.total = response?.data?.Payload?.total ?? 0;
            this.loading = false;
            this.setOverlayVisible({ visible: false });
        },
        getSerializedFilter() {
            let { sortBy, sortDesc, page, itemsPerPage, SearchStr, Status } = this.filter;

            let OrderDir = sortDesc.length <= 0 ? false : sortDesc[0];
            let sortColumn = sortBy.length <= 0 ? "template_name" : sortBy[0];
            let OrderBy = this.$options.columnIndex[sortColumn];

            return JSON.stringify({ SearchStr, Status, OnlyPublished: this.status == "1", OrderBy, OrderDir, Limit: itemsPerPage, Offset: (page - 1) * itemsPerPage });
        },
        async Refresh() {
            await this.getData(true);
        },
        async rowClick(e, row) {
            this.setOverlayVisible({ visible: true });
            await this.$router.push({ name: 'TemplateCard', query: { id: row.item.id, common: this.status == "1" }, params: { id: row.item.id, common: this.status == "1" }});
            this.setOverlayVisible({ visible: false });
        }
    },
    watch: {
        filter: {
            handler() {
                this.getData();
            },
            deep: true,
        },
    },
    async created() {
        this.setOverlayVisible({ visible: true });
        
        let fakeMenu =
        [
            { Action: "Refresh", Icon: "refresh", Items: null, Text: "Обновить", ToolTip: "Обновить_форму", Type: null, Localize: true }
        ];

        this.$store.commit('documents/toolbar/SET_MENU', { menu: fakeMenu });

        let filterResponse = await httpAPI({
            url: `api/document-templates/templates/filter`,
            method: 'GET',
        });
        
        if (filterResponse)
            this.filterDataSource = filterResponse.data.Payload;

        this.setOverlayVisible({ visible: false });
    }
}
</script>
